<div class="center-container">
  <!-- <div class="jobcard-header">{{"bikeshop.dashboard.jobcard" | translate }}: #{{ jobcard }}</div> -->
  <div class="attachment-container">
    <div>
      <div class="attachments">
        <div *ngIf="!loading && attachments.length === 0" class="no-attachments">
          {{ 'bikeshop.modal.update_job_card.attachments.no_attachments' | translate }}
        </div>
        <!-- <div *ngFor="let item of attachments" class="attachment">
          <div style="width: 100%;display: flex;">
            <span class="fa fa-file-image-o" (click)="openAttachment(item)"></span>
            <span class="filename" (click)="openAttachment(item)">{{item.fileName}}</span>
            <span *ngIf="item.serviceLogID===0" class="fa hubtiger-delete" style="font-size: 24px;" (click)="deleteAttachment(item)"></span>
          </div>
        </div> -->
        <div class="attachment-images">
          <div *ngFor="let item of attachments">
            <div *ngIf="item.mediaType.indexOf('image') > -1" style="position: relative;">
              <img [src]="item.mediaURL" />
              <span class="fa fa-expand" (click)="openAttachment(item)"></span>
              <span class="fa fa-trash-o" (click)="deleteAttachment(item)"></span>
            </div>
            <div *ngIf="item.mediaType.indexOf('image') == -1" (click)="openAttachment(item)" class="file-attachment">
              <span class="fa fa-file-o"></span>
            </div>
            <div class="flex">
              <div class="filename">
                <p-inplace #fileName>
                  <span pInplaceDisplay>
                    {{ item.fileName }}
                  </span>
                  <span pInplaceContent>
                    <div class="p-inputgroup">
                      <input pInputText type="text" [(ngModel)]="item.fileName"
                        (keyup.enter)="updateFileName(fileName, item)" (blur)="updateFileName(fileName, item)" />
                      <span class="p-inputgroup-addon" (click)="updateFileName(fileName, item)"><i class="fa fa-check"
                          [ngClass]="{ 'red': item.fileName && item.fileName.length > 0 }"></i></span>
                    </div>
                  </span>
                </p-inplace>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="loading">
          <p-progressSpinner [style]="{width: '30px', height: '30px'}" animationDuration=".5s"></p-progressSpinner>
        </div>
      </div>
    </div>
  </div>

  <div class="button-container">
    <div class="row">
      <div class="col-md-8 col-xl-4"></div>
      <div class="col-md-4 col-xl-4">
        <button pButton type="button" class="p-button-raised full-width" (click)="fileUpload.click()"
          [disabled]="loading"
          label="{{'bikeshop.modal.update_job_card.attachments.add_attachment' | translate}}"></button>
        <input #fileUpload type="file" multiple accept="image/*;capture=camera" style="display: none"
          (change)="addAttachment($event)">
      </div>
      <div class="col-md-0 col-xl-4"></div>
    </div>
  </div>
</div>